import { render } from "./TaskProcessing.vue?vue&type=template&id=57f895cd&scoped=true&ts=true"
import script from "./TaskProcessing.vue?vue&type=script&lang=ts"
export * from "./TaskProcessing.vue?vue&type=script&lang=ts"

import "./TaskProcessing.vue?vue&type=style&index=0&id=57f895cd&lang=scss&scoped=true"
import "./TaskProcessing.vue?vue&type=style&index=1&id=57f895cd&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f895cd"]])

export default __exports__